/**
 * Lazy Loading for Third-Party Apps (Judge.me Reviews)
 * Defers loading of heavy third-party scripts until user interaction
 */

class LazyAppLoader {
  constructor() {
    this.loaded = false;
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupLazyLoading());
    } else {
      this.setupLazyLoading();
    }
  }

  setupLazyLoading() {
    // Find Judge.me review containers
    const reviewContainers = document.querySelectorAll('[data-jm]');
    
    if (reviewContainers.length === 0) {
      return; // No review widgets found
    }

    // Create intersection observer for scroll-based loading
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.loaded) {
          this.loadJudgeMe();
          observer.disconnect(); // Only load once
        }
      });
    }, {
      rootMargin: '200px' // Start loading 200px before widget comes into view
    });

    // Observe all review containers
    reviewContainers.forEach(container => observer.observe(container));

    // Also load on first user interaction (click, scroll, keypress)
    const interactionEvents = ['click', 'scroll', 'keypress', 'touchstart'];
    const handleInteraction = () => {
      if (!this.loaded) {
        this.loadJudgeMe();
        // Remove all interaction listeners
        interactionEvents.forEach(event => 
          document.removeEventListener(event, handleInteraction, { passive: true })
        );
      }
    };

    // Set up interaction-based loading with small delay to avoid blocking
    setTimeout(() => {
      interactionEvents.forEach(event => 
        document.addEventListener(event, handleInteraction, { passive: true })
      );
    }, 1000); // Wait 1 second after page load
  }

  loadJudgeMe() {
    if (this.loaded) return;
    
    this.loaded = true;
    
    // Re-enable Judge.me scripts by triggering their initialization
    if (window.jdgm) {
      // Judge.me is already loaded, just initialize
      window.jdgm.init();
    } else {
      // Force Judge.me to load by dispatching custom event
      const event = new CustomEvent('judgeme:load', { bubbles: true });
      document.dispatchEvent(event);
    }
    
    console.log('Judge.me reviews loaded lazily');
  }
}

// Initialize lazy loading
new LazyAppLoader();